import { AfterContentInit, Component, OnInit } from "@angular/core";
import { ConfigService } from "./services/config.service";
import { ConfiguracionService } from "./services/configuracion/configuracion.service";
import { Router, NavigationEnd } from "@angular/router";
declare let gtag: Function;
declare let fbq: Function;
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit, AfterContentInit {
  title = "automotive-agendamiento";
  UrlBucket = "";
  private MasterUserId = localStorage.getItem("MasterUserId");
  private themeWrapper = document.querySelector("body");
  private IcoLogo: string = "";
  p_i_marca;
  constructor(
    private cConfiguracionService: ConfiguracionService,
    public cConfigService: ConfigService,
    private router: Router
  ) {
    this.p_i_marca = cConfigService.onObtenerMarcaBase();
    //
    router.events.subscribe((y: NavigationEnd) => {
      if (y instanceof NavigationEnd) {
        if (gtag != undefined && fbq != undefined) {
          let aMarca =   window.location.host.split(".");
          if (aMarca[0] == "subaru") {
            gtag("config", "GTM-5HC3NJX", { page_path: y.url });
            fbq("track", "PageView"); 
          }
          if (aMarca[0] == "dfsk") {
            gtag("config", "GTM-MC3NBDJ", { page_path: y.url });
            fbq("track", "PageView"); 
          }
          if (aMarca[0] == "bmw") {
            gtag('config','G-9VP7Z0MBGF',{'page_path' : y.url});
            fbq('track', 'PageView'); 
          }
          if (aMarca[0] == "mini") {
            gtag("config", "G-6CFNBCXVJP", { page_path: y.url });
            fbq("track", "PageView"); 
          }
          if (aMarca[0] == "motorrad") {
            gtag("config", "G-2TPG64GQQ4", { page_path: y.url });
            fbq("track", "PageView"); 

          }
        }
      }
    });
    //
  }
  ngAfterContentInit(): void {
    this.cConfigService.isLoadingInitialComplete = true;
  }
  ngOnInit(): void {
    this.onInitApllication();
  }
  onInitApllication() {
    let Name = window.location.host;
    Name = "subaru.inchcapelatam.app".toLocaleLowerCase();
    //Name = "bmwqa.inchcapelatam.app".toLocaleLowerCase();
    //Name = "dfskqa.inchcapelatam.app".toLocaleLowerCase();
    let oDataSend = {
      masterUserId: null,
      name: Name,
      property: "",
    };
    this.cConfigService.onObtenerconfiguraciones(oDataSend).subscribe(
      (oDataResponse) => {
        oDataResponse = oDataResponse.filter((oEle) => oEle.IsActived == true);
        if (oDataResponse.length > 0) {
          oDataResponse.forEach((element) => {
            switch (element.Property) {
              case "TOKEN":
                localStorage.setItem("Token", element.Value);
                break;
              case "APPID":
                localStorage.setItem("AppId", element.Value);
                break;
              case "MASTERUSERID":
                this.MasterUserId = element.Value;
                localStorage.setItem("MasterUserId", element.Value);
                break;
              case "COMPANYID":
                localStorage.setItem("CompanyId", element.Value);
                break;
              case "BRANDID":
                localStorage.setItem("BrandId", element.Value);
                break;
              case "TITLE":
                document.getElementById("titulo-general").innerHTML =
                  element.Value;
                break;
              case "ICO":
                this.IcoLogo = element.Value;
                break;
              case "PRIMARY-COLOR":
                this.themeWrapper.style.setProperty(
                  "--color-primary",
                  element.Value
                );

                var rgbColorPrimary = this.hexToRgb(element.Value);
                let mColorsPromary = this.materialColors(rgbColorPrimary);
                console.log(mColorsPromary);
                mColorsPromary.darkerColors.forEach((elementColor) => {
                  this.themeWrapper.style.setProperty(
                    "--primary-" + elementColor.name,
                    this.rgba2hex(
                      "rgba(" +
                        elementColor.r +
                        "," +
                        elementColor.g +
                        "," +
                        elementColor.b +
                        "," +
                        elementColor.a +
                        ")"
                    )
                  );
                });
                mColorsPromary.lighterColors.forEach((elementColor) => {
                  this.themeWrapper.style.setProperty(
                    "--primary-" + elementColor.name,
                    this.rgba2hex(
                      "rgba(" +
                        elementColor.r +
                        "," +
                        elementColor.g +
                        "," +
                        elementColor.b +
                        "," +
                        elementColor.a +
                        ")"
                    )
                  );
                });

                break;
              case "ACCENT-COLOR":
                this.themeWrapper.style.setProperty(
                  "--color-accent",
                  element.Value
                );
                let rgbColorAccent = this.hexToRgb(element.Value);
                let mColorsAccent = this.materialColors(rgbColorAccent);
                mColorsAccent.darkerColors.forEach((elementColor) => {
                  this.themeWrapper.style.setProperty(
                    "--accent-" + elementColor.name,
                    this.rgba2hex(
                      "rgba(" +
                        elementColor.r +
                        "," +
                        elementColor.g +
                        "," +
                        elementColor.b +
                        "," +
                        elementColor.a +
                        ")"
                    )
                  );
                });
                mColorsAccent.lighterColors.forEach((elementColor) => {
                  this.themeWrapper.style.setProperty(
                    "--accent-" + elementColor.name,
                    this.rgba2hex(
                      "rgba(" +
                        elementColor.r +
                        "," +
                        elementColor.g +
                        "," +
                        elementColor.b +
                        "," +
                        elementColor.a +
                        ")"
                    )
                  );
                });
                break;
              case "WARNING-COLOR":
                this.themeWrapper.style.setProperty(
                  "--color-warn",
                  element.Value
                );
                let rgbColorWarning = this.hexToRgb(element.Value);
                let mColorsWarning = this.materialColors(rgbColorWarning);
                mColorsWarning.darkerColors.forEach((elementColor) => {
                  this.themeWrapper.style.setProperty(
                    "--warn-" + elementColor.name,
                    this.rgba2hex(
                      "rgba(" +
                        elementColor.r +
                        "," +
                        elementColor.g +
                        "," +
                        elementColor.b +
                        "," +
                        elementColor.a +
                        ")"
                    )
                  );
                });
                mColorsWarning.lighterColors.forEach((elementColor) => {
                  this.themeWrapper.style.setProperty(
                    "--warn-" + elementColor.name,
                    this.rgba2hex(
                      "rgba(" +
                        elementColor.r +
                        "," +
                        elementColor.g +
                        "," +
                        elementColor.b +
                        "," +
                        elementColor.a +
                        ")"
                    )
                  );
                });
                break;
              case "LOGO":
                localStorage.setItem("Logo", element.Value);
                break;
              case "FONT":
                this.themeWrapper.style.setProperty(
                  "--font-primary",
                  element.Value
                );
                break;
              default:
                break;
            }
          });
        }

        document
          .getElementById("body-general")
          .setAttribute("class", "default-theme");

        console.log(this.cConfigService.isLoadingInitialComplete);
      },
      (err) => {},
      () => {
        this.onGetUrlBaseBucket();
      }
    );
  }

  onGetUrlBaseBucket() {
    let oDataSend = {
      BucketType: "public",
      MasterUserId: this.MasterUserId,
    };
    this.cConfiguracionService.ObtenerUrlBucketGet(oDataSend).subscribe(
      (oRes) => {
        if (oRes.length > 0) {
          this.UrlBucket = oRes[0].Value;
          localStorage.setItem("UrlBucketS3", this.UrlBucket);
          document
            .getElementById("favicon")
            .setAttribute("href", this.UrlBucket + this.IcoLogo);
        }
      },
      (oerr) => {},
      () => {}
    );
  }

  onSetStyle() {
    let stheme = "";
    let sTitulo = "";
    let favicon = "";
    switch (this.p_i_marca) {
      case 1:
        stheme = "subaru-theme";
        sTitulo = "Subaru Perú – Agendamiento online";
        favicon = "subaru.ico";
        break;
      case 2:
        stheme = "dfsk-theme";
        sTitulo = "DFSK Perú – Agendamiento online";
        favicon = "dfsk.ico";
        break;
      case 3:
        stheme = "bmw-theme";
        sTitulo = "BMW Perú – Agendamiento online";
        favicon = "bmw.ico";
        break;
      default:
        stheme = "bmw-theme";
        sTitulo = "BMW Perú – Agendamiento online";
        favicon = "bmw.ico";
        break;
    }
    document.getElementById("body-general").setAttribute("class", stheme);
    document.getElementById("titulo-general").innerHTML = sTitulo;
    document.getElementById("favicon").setAttribute("href", favicon);
  }
  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }
  materialColors(color) {
    return {
      lighterColors: [
        {
          r: color.r,
          g: color.g,
          b: color.b,
          a: 0.13,
          name: "50",
        },
        {
          r: color.r,
          g: color.g,
          b: color.b,
          a: 0.31,
          name: "100",
        },
        {
          r: color.r,
          g: color.g,
          b: color.b,
          a: 0.5,
          name: "200",
        },
        {
          r: color.r,
          g: color.g,
          b: color.b,
          a: 0.7,
          name: "300",
        },
        {
          r: color.r,
          g: color.g,
          b: color.b,
          a: 0.85,
          name: "400",
        },
        {
          r: color.r,
          g: color.g,
          b: color.b,
          a: 1,
          name: "500",
        },
      ],
      darkerColors: [
        {
          r: color.r,
          g: color.g,
          b: color.b,
          a: 0.91,
          name: "600",
        },
        {
          r: color.r,
          g: color.g,
          b: color.b,
          a: 0.81,
          name: "700",
        },
        {
          r: color.r,
          g: color.g,
          b: color.b,
          a: 0.71,
          name: "800",
        },
        {
          r: color.r,
          g: color.g,
          b: color.b,
          a: 0.52,
          name: "900",
        },
      ],
    };
  }
  rgba2hex(orig) {
    var a,
      isPercent,
      rgb = orig
        .replace(/\s/g, "")
        .match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
      alpha = ((rgb && rgb[4]) || "").trim(),
      hex = rgb
        ? (rgb[1] | (1 << 8)).toString(16).slice(1) +
          (rgb[2] | (1 << 8)).toString(16).slice(1) +
          (rgb[3] | (1 << 8)).toString(16).slice(1)
        : orig;

    if (alpha !== "") {
      a = alpha;
    } else {
      a = 1;
    }
    // multiply before convert to HEX
    a = ((a * 255) | (1 << 8)).toString(16).slice(1);
    hex = hex + a;

    return "#" + hex;
  }
}
